<template>
  <div class="flex flex-col sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-[520px]">
      <div class="items-center bg-white px-6 md:px-12 pb-6 shadow sm:rounded-lg">
        <div class="flex flex-col items-center justify-center pt-14">
          <Icon class="text-5xl text-primary" name="encrypted" is-filled />
          <SectionHeader
            class="mx-auto !justify-center pb-2"
            :title="__('Reset Password')"
          >
          </SectionHeader>
          <p class="text-gray-600 text-md text-center mb-8">
            {{ __('If your email is registered, you will receive a password reset link.') }}
          </p>

        </div>
        <div>
          <form @submit.prevent="handleSubmit">
            <div class="flex flex-col">
              <InputEmail
                id="email"
                v-model:value="values.email"
                v-model:errors="errors.email"
                :label="__('Email')"
                :placeholder="__('Your email')"
                required
              />

              <div
                v-if="errorMessage || successMessage"
                class="mt-8 flex flex-col"
              >
                <div
                  v-if="errorMessage"
                  class="flex items-center gap-2 rounded-lg border border-red-400 bg-red-100 p-4 text-red-700"
                >
                  <span
                    class="material-symbols-outlined text-xl text-red-600"
                    style="font-variation-settings: 'FILL' 1"
                  >
                    error
                  </span>
                  <span>{{ errorMessage }}</span>
                </div>

                <div
                  v-if="successMessage"
                  class="flex items-center gap-2 rounded-lg border border-green-400 bg-green-100 p-4 text-green-700"
                >
                  <span
                    class="material-symbols-outlined text-xl text-green-600"
                    style="font-variation-settings: 'FILL' 1"
                  >
                    check_circle
                  </span>
                  <span>{{ successMessage }}</span>
                </div>
              </div>
            </div>

            <div
              class="mt-8 flex flex-col gap-2 md:flex-row-reverse md:justify-center items-center"
            >
              <Button
                class="flex items-center justify-center gap-1.5"
                :type="isLoading ? 'button' : 'submit'"
                :disabled="isLoading"
                style="width: 10rem !important"
              >
                <Icon
                  v-if="isLoading"
                  class="animate-spin text-lg"
                  name="progress_activity"
                />
                <span>{{ __('Send Email') }}</span>
              </Button>
            </div>
          </form>
        </div>
        <div class="flex flex-col items-center justify-center">
          <a @click="redirectToLogin" class="cursor-pointer text-md font-medium text-gray-700 underline mt-8 flex items-center gap-2" >
            <img src="/images/front/arrow_back.png" alt="Back Arrow" class="w-5 h-5" />
            {{ __('Back to login') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { __ } from '@/helpers';
  import { Button } from '../../../../components/block/button';
  import { Icon } from '../../../../components/block/icon';
  import { InputEmail } from '../../../../components/form/input-email';
  import { SectionHeader } from '../../../components/section-header';
  import axios from 'axios';

  const values = ref({
    email: ''
  });


  const errors = ref({
    email: []
  });

  const isLoading = ref(false);

  const errorMessage = ref('');
  const successMessage = ref('');
  const redirectToLogin = () => {
    window.location.href = route('front.auth.company.login');
  }

  async function handleSubmit() {
    const requiredFieldKeys = ['email'];
    let firstElement;

    requiredFieldKeys.forEach((key) => {
      if (!values.value[key]) {
        errors.value[key] = [__('This field is required')];

        const element = document.getElementById(key);

        if (element && !firstElement) {
          firstElement = element;
        }
      }
    });

    if (Object.values(errors.value).some((error) => error.length)) {
      if (firstElement) {
        firstElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    isLoading.value = true;
    errorMessage.value = '';

    try {
      const response = await axios.post(route('company.password.send_reset_link'), values.value);

      successMessage.value = response.data.message;
      errorMessage.value = '';
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage.value = error.response.data.message;
      } else {
        errorMessage.value = __(
          'An unexpected error has occurred. Please try again later.'
        );
      }
    }

    isLoading.value = false;
  }
</script>
